import React from 'react';
import { styled } from 'styled-components';
import ApproveWait from "@src/assets/ApproveWait.png";

interface ApproveCheckProps {
    isApproved: boolean;
    isRejected: boolean;
}

const ApproveCheck = ({ isApproved, isRejected }: ApproveCheckProps) => {
    if (isApproved) return null;

    return (
        <Container>
            <ContentWrapper>
                <IconImage src={ApproveWait} alt="승인 상태" />
                <StatusText>
                    {isRejected 
                        ? `매수 신청 대리인 등록 승인이 거절되었습니다.\n매수신청대리인 등록증을 새롭게 추가해주세요`
                        : "매수 신청 대리인 등록 승인이 현재 대기 상태입니다."
                    }
                </StatusText>
            </ContentWrapper>
        </Container>
    );
};

export default ApproveCheck;

const Container = styled.div`
    width: 100%;
    padding: 0px;
    background-color: #fff;
    border-radius: 12px;
`;  

const ContentWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const IconImage = styled.img`
    width: 32px;
    height: 32px;
`;

const StatusText = styled.span`
    font-size: 12px;
    font-weight: 400;
    color: #FF6B6B;
    white-space: pre-line;
`;
